import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/login/Home";
import "./App.css";
import { StyledEngineProvider } from "@mui/material/styles";
import AppRoute from "./components/AppRoute/AppRoute";
import {routes} from "./routes";  
import ProtectedRoute from "./components/Protected/ProtectedRoute";
const App = () => {
  return (
    <>
      <StyledEngineProvider injectFirst>
        <Router>
            <Routes>
              <Route exact path="/cost-ui" element={<Home />} />
              <Route exact path="/" element={<Home />} />
      
              {routes.map(r=>{  
                const {exact,path,element,permissions} = r;
                return (
                  <Route 
                    exact={exact} 
                    path={path} 
                    key={path}
                    element={
                      <ProtectedRoute>
                          <AppRoute Element={element} permission={permissions} />
                      </ProtectedRoute>
                  } 
                  />
                )
              })}
              <Route
                path="*"
                element={
                  <main className="page_404" style={{}}>
                    <p>There's nothing here!</p>
                  </main>
                }
              />
            </Routes>
        </Router>
      </StyledEngineProvider>
    </>
  );
};

export default App;
